import queryString from 'query-string'
import { AuthenticationError } from '../graphql/beehive-sdk'
import { mapWidgetAttributesToBeedirect } from '../lib/attributes'
import { sendHostMessage } from '../lib/beedirect-modal'
import { calculateLease } from '../lib/calculate-lease'
import { createInvalidTokenErrorMessage } from '../lib/create-error-message'
import { getThemeFromUrlParams, applyTheme } from './theme'
;(function () {
    function openBeedirect() {
        const qs = new URLSearchParams()
        const params = queryString.parse(location.search) as ButtonUrlParams
        const beedirectAttributes = mapWidgetAttributesToBeedirect(params)
        Object.entries(beedirectAttributes).forEach(([key, value]) => {
            qs.append(key, value ?? '')
        })

        sendHostMessage({
            event: 'lease:open',
            value: { queryString: qs.toString() },
        })

        return false
    }

    function createButtons(text: string) {
        const container = document.createElement('div')
        container.className = 'form-buttons'

        const button = document.createElement('button')
        button.type = 'button'
        button.innerText = text
        button.className = 'button  button--primary'
        button.setAttribute('data-hook', 'button-widget-beedirect')
        button.onclick = openBeedirect
        container.appendChild(button)

        return container
    }

    async function createWidget(urlParams: ButtonUrlParams) {
        const theme = getThemeFromUrlParams(urlParams)
        if (!theme) {
            throw new Error(
                'Beequip widget not rendered: invalid theme configuration'
            )
        }

        try {
            // This call is necessary to check if the intermediary token is valid
            await calculateLease({
                objectYear: new Date().getFullYear(),
                intermediaryToken: urlParams['token'],
            })
        } catch (error) {
            if (error instanceof AuthenticationError) {
                // eslint-disable-next-line no-console
                console.error(error)

                return createInvalidTokenErrorMessage('Ongeldig token')
            }
        }

        const container = document.createElement('div')
        container.appendChild(
            createButtons(urlParams['button-text'] ?? 'Bereken je leaseprijs')
        )

        applyTheme(container, theme)

        return container
    }

    function validateRequiredParams(urlParams: ButtonUrlParams) {
        return ['token'].filter(
            (key) => !urlParams[key as keyof typeof urlParams]
        )
    }

    const urlParams = queryString.parse(location.search) as ButtonUrlParams
    const invalidParamKeys = validateRequiredParams(urlParams)
    if (invalidParamKeys.length !== 0) {
        throw new Error(
            `Beequip widget not rendered due to missing required parameters: '${invalidParamKeys.join(
                ', '
            )}'`
        )
    }

    createWidget(urlParams).then((widget) => {
        if (widget) {
            document.getElementsByTagName('body')[0].appendChild(widget)

            window.dataLayer?.push({
                widgetHost: window.location.href,
                widgetType: 'button',
            })
        }
    })
})()
